import { render, staticRenderFns } from "./OBListModal.vue?vue&type=template&id=41e4cfa2&scoped=true&"
import script from "./OBListModal.vue?vue&type=script&lang=js&"
export * from "./OBListModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e4cfa2",
  null
  
)

export default component.exports